export default __webpack_public_path__ + "static/clear-headings-dont-2bf985c08322f4165aa68c014ffbc29c.png";